import { TApplicationState } from '../../types/redux';

export const selectEstimationTarget = (state: TApplicationState) => {
  return state.filters.estimationTarget;
};
